import React from 'react';
import { Helmet } from 'react-helmet';

import type MarketStats from 'app/shared/models/MarketStats';
import { getStructuredData } from './StructuredData';

interface PageHeadProps {
    areaName: string | null;
    hasData: boolean;
    faqParams: MarketStats;
    canonicalURL: string | null;
}

const PageHead: React.FunctionComponent<PageHeadProps> = (props) => {
    const { hasData, areaName, faqParams, canonicalURL } = props;
    const link = [];
    if (canonicalURL) {
        link.push({
            rel: 'canonical',
            href: canonicalURL
        });
    }
    return (
        <Helmet
            meta={[
                {
                    name: 'description',
                    content: areaName
                        ? `Research rental market trends in ${areaName}. See the average rent, monthly and annual rent changes and compare rental costs across locations.`
                        : 'Choose another area.'
                }
            ]}
            title={
                areaName
                    ? `Average Rental Price in ${areaName} & Market Trends | Zillow Rental Manager`
                    : 'Market not found | Zillow Rental Manager'
            }
            script={hasData ? getStructuredData(faqParams) : undefined}
            link={link}
        />
    );
};

export default PageHead;
